module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"pageTitle":"Content Home Page","staticContent":"Contenuti statici","imageGalleries":"Gallery immagini","authors":"Autori","articleCategories":"Categorie degli articoli","articles":"Articoli","webNewsTypes":"Tipologie di WebNews","webNews":"WebNews","menus":"Menu"}}')
  delete Component.options._Ctor
}
